export default "__VITE_ASSET__CIxvFVqE__"